module.exports = ".tab-content{overflow:auto}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/merchant-tools/merchant-tools.component.scss
// module id = 1205
// module chunks = 0